/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {MarkSuggestedActionUsedRequest} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/suggested_actions_messages.pb'
import {MarkSuggestedActionUsedResponse} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/suggested_actions_messages.pb'


export const markSuggestedActionUsed = (request: MarkSuggestedActionUsedRequest, options?: CashRequestOptions) => post<MarkSuggestedActionUsedRequest, MarkSuggestedActionUsedResponse>("/cash-app/frontdoor/mark-suggested-action-used", request, {...options, rejectOnError: true })